'use client';

import React from 'react';
import { TableRow } from '../Card';
import { TypeIcon, Typography } from 'src/components';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/pro-solid-svg-icons';
import { useLogging } from 'src/context/logging';
import Link from 'next/link';
import { getProfileUrl } from 'src/utils/profileUrl';
interface LocationRowItemProps {
  location: {
    provider_id: string;
    type: string;
    name: string;
    percentage: number;
    obfuscated: boolean;
    soc_type?: string;
  };
}

const LocationRowItem = ({ location }: LocationRowItemProps) => {
  const log = useLogging();
  const percentage =
    location?.percentage || location?.percentage === 0
      ? `${location?.percentage}%`
      : 'Unavailable';

  const name = location?.name || 'Other';
  const hasProviderId = location?.provider_id;
  return (
    <TableRow borderColor="#F0F4F8">
      {hasProviderId ? (
        <>
          <Link
            id={`volume-by-location-provider-${location?.provider_id}`}
            href={getProfileUrl(location?.type, location?.provider_id)}
            scroll={false}
            className="flex items-center w-full gap-2 text-[#021B9C] no-underline"
            onClick={(e) => {
              e.stopPropagation();
              log.event('Location Clicked', {
                source: 'web',
                location: 'VolumeByLocation',
                provider_id: location?.provider_id,
              });
            }}
          >
            <TypeIcon
              type={location.soc_type || location.type}
              className="mx-0 text-link"
            />
            <Typography variant="body2" className="font-medium !text-link">
              {name}
              <Icon icon={faExternalLinkAlt} className="pl-1" size="xs" />
            </Typography>
          </Link>
          <Typography variant="body2" className="text-[#292B33]">
            {percentage}
          </Typography>
        </>
      ) : (
        <>
          <div className="flex items-center gap-2 w-full">
            <Typography variant="body2" className="font-medium">
              {name}
            </Typography>
          </div>
          <Typography variant="body2">{percentage}</Typography>
        </>
      )}
    </TableRow>
  );
};

export default LocationRowItem;
